import {EditReaderModel} from "../../models/edit/EditReaderModel";
import {NotificationService} from "../../services/NotificationService";
import {Reader} from "../../entities/Reader";
import {EditBaseCtrl} from "./EditBaseCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";

export class EditReaderCtrl extends EditBaseCtrl<Reader> {
    $scope:any;
    public static $inject = ['$scope','$state','$stateParams','NotificationService','EditReaderModel'];
    constructor($scope:any,
                public stateService:StateService,
                public stateParamsService:StateParams,
                public notifyService:NotificationService,
                public editModel:EditReaderModel){
        super($scope, stateService, stateParamsService, notifyService, editModel);
        this.$scope = $scope;
        this.model = editModel;
        $scope.vm = this;
        this.loadData().then((ok)=>{
          //this.$scope.$watch(() => this.model.entity.port, this.model.selectedConnectionChanged,false);
          this.$scope.$watch(() => this.model.entity.readerModel,(newValue: string, oldValue: string) => {
            if(newValue != oldValue)
              this.editModel.selectedModelChanged();
          });          
          this.$scope.$watch(() => this.editModel.devicePropertyValues,(newValue: string, oldValue: string) => {
            this.editModel.saveDevicesettings();
          },true);          
        });
    }
    pagingRoute(): string {
        return "admin.readers";
    }
}
